import { CreateCommissionDialog } from "@/pages/commission/CreateCommissionDialog";
import { useAuth } from "@/App";

export function CommissionsPageIntro({ onCreated }: { onCreated: () => void }) {
  const { user } = useAuth();

  return (
    <div className="mb-6 flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between">
      <p className="max-w-2xl text-sm text-muted-foreground">
        Commissions enregistrées, montants associés et demandes de correction en cours.
      </p>
      {user?.role !== "consultant" && <CreateCommissionDialog onCreated={onCreated} />}
    </div>
  );
}
